import Datepicker from 'rctui/Datepicker';
import React from 'react';
import PropTypes from 'prop-types';
import I18n from 'jsx!Component/I18n';

class DateTimePicker extends React.Component {
  static displayName = 'DateTimePicker';

  static defaultProps = {
    disabled: false,
    showPresets: false,
    name: '',
    value: ''
  };

  static propTypes = {
    name: PropTypes.string
  };

  presets = {
    today: 0,
    day3: -3,
    week: -7,
    month: -30,
  };

  constructor(props) {
    super(props);
    let x = new Date();
    this.utcOffset = x.getTimezoneOffset() * 60000;
  }

  setPreset = (preset, e) => {
    e.preventDefault();
    let value = Date.now() + this.presets[preset] * 86400000;
    this.props.onChange(this.props.name, value);
  };

  timeToVal(value) {
    let outValue = value;
    if (outValue === undefined || outValue == null) {
      outValue = '';
    }

    return outValue;
  }

  onChange = (value) => {
    let outValue = this.timeToVal(value);

    if (outValue !== '' && outValue !== 0) {
      outValue = value - this.utcOffset;
    }

    this.props.onChange(this.props.name, outValue);
  };

  render() {
    let presets = [];
    if (this.props.showPresets) {
      for (let preset in this.presets) {
        presets.push(<a href="#" onClick={(e) => this.setPreset(preset, e)} key={preset}><I18n
          message={"preset." + preset}/></a>);
      }
    }

    let value = this.timeToVal(this.props.value);
    if (value !== '' && value !== 0) {
      value = this.props.value + this.utcOffset;
    }

    return (
      <div>
        <Datepicker onChange={this.onChange} unixtime value={value}/>
        <div className="presets">
          {presets}
        </div>
      </div>
    );
  }
}

export default DateTimePicker;



// WEBPACK FOOTER //
// ./src/js/Component/DateTimePicker.jsx